<template>
  <div
    v-if="gamePhaseState.showAngle"
    class="angle-status-container"
    :class="isMobile() ? '' : 'angle-status-container-mobile'"
  >
    <div class="angle-wrapper">
      <angle-arrow
        :key="gamePhaseState.angle"
        :color="gamePhaseState.angleColor"
        :angle="gamePhaseState.angle"
        style="transform-origin: top right"
      />
    </div>
    <div
      class="draw-bar"
      :style="transformCoef"
    >
      <speed-bar-v-2
        show-mark
        show-arrows
        horizontal
        rainbow
        arrows-tied-to-mark
        :fill-size="gamePhaseState.speedPower"
        :mark="100 / 15 * 13"
        :is-scaled="false"
      />
      <div class="draw-label">
        {{ $t('draw') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import {
  WindowAspect,
  AngleArrow,
  SpeedBarV2
} from '@powerplay/core-minigames-ui-ssm'
import { defineComponent } from 'vue'
import { gamePhaseState } from '@/stores'

export default defineComponent({
  components: {
    AngleArrow,
    SpeedBarV2
  },
  mixins: [WindowAspect],
  data() {

    return {
      gamePhaseState: gamePhaseState()
    }

  },
  computed: {
    transformCoef() {

      return {
        transform: `scale(${ this.scaleCoef }) translate(0, 0)`,
        transformOrigin: 'bottom center'
      }

    },
  }
})

/* eslint-disable */
</script>

<style lang="less">
.angle-status-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  &.angle-status-container-mobile {
    position: fixed;
  }
  
  .angle-wrapper {
    width: 50%;
    position: absolute;
    top: 30%;
    display: flex;
    justify-content: flex-end;
  }

  .draw-bar {
    width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    bottom: 20%;
    
    .draw-label {
      width: 190px;
      margin-top: calc(-50% + 60px);
      background-image: linear-gradient(to right, rgba(74, 75, 117, 0) 0%, rgba(74, 75, 117, 0.9) 20%, rgba(74, 75, 117, 0.9) 80%, rgba(74, 75, 117, 0) 100%);
      
      text-shadow: 0.6px 0.8px 0.9px rgba(0, 0, 0, 0.71);
      font-size: 28px;
      font-weight: 600;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
    }
  }
}
</style>
